(() => {
  'use strict';

  class CartBar extends HTMLElement {
    constructor() {
      super();

      this.section = this.closest('product-info');
      this.form = this.section.querySelector('[data-product-form]');
      this.formWrapper = (theme.settings.productPageSticky && this.section.querySelector('[data-form-wrapper]')) || this.form;
      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
      this.boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.addEventListener('click', this.boundHandleClick);
      document.addEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.addEventListener('theme:resize', this.boundSetCartBarHeight);
      document.addEventListener('theme:product:add-error', this.handleProductAddError);
    }

    handleClick(event) {
      const cartBarAddButton = event.target.closest('[data-cart-bar-add-to-cart]');

      if (cartBarAddButton) {
        event.preventDefault();
        this.addOneToCart(cartBarAddButton);
        return;
      }

      if (event.target.closest('[data-cart-bar-scroll]')) {
        event.preventDefault();
        this.scrollToTop();
      }
    }

    addOneToCart(cartBarAddButton) {
      const addToCartButton = this.form.querySelector('[data-add-to-cart]');

      if (!addToCartButton || addToCartButton.hasAttribute('disabled')) {
        this.resetCartBarButton(cartBarAddButton);
        this.scrollToTop();
        return;
      }

      cartBarAddButton.classList.add('is-loading');
      cartBarAddButton.setAttribute('disabled', 'disabled');

      const quantityInput = this.form.querySelector('[data-quantity-input][name="quantity"], input[name="quantity"]');
      const restoreQuantity = this.setQuantityToOne(quantityInput);

      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        restoreQuantity();
        this.resetCartBarButton(cartBarAddButton);
        return;
      }

      addToCartButton.click();

      // FormData is built synchronously by the theme after the submit click.
      setTimeout(restoreQuantity, 0);
    }

    setQuantityToOne(quantityInput) {
      if (!quantityInput) {
        return () => {};
      }

      const previousValue = quantityInput.value;
      quantityInput.value = '1';

      return () => {
        quantityInput.value = previousValue;
      };
    }

    resetCartBarButton(cartBarAddButton) {
      cartBarAddButton.classList.remove('is-loading');
      cartBarAddButton.removeAttribute('disabled');
    }

    handleProductAddError() {
      if (this.querySelector('[data-cart-bar-add-to-cart]')) {
        this.scrollToTop();
      }
    }

    scrollToTop() {
      const variantSelects = this.section.querySelector('variant-selects');
      const top = (window.theme.isMobile() ? variantSelects || this.form : this.section).getBoundingClientRect().top;
      window.theme.scrollTo(window.theme.isMobile() ? top - 10 : top);
    }

    toggleCartBarOnScroll() {
      if (this.formWrapper) {
        const isPastForm = window.scrollY > this.formWrapper.offsetTop + this.formWrapper.offsetHeight;
        this.classList.toggle('is-visible', isPastForm);
      }
    }

    setCartBarHeight() {
      const height = this.offsetHeight;
      document.documentElement.style.setProperty('--cart-bar-height', `${height}px`);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:product:add-error', this.handleProductAddError);
      document.removeEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.removeEventListener('theme:resize', this.boundSetCartBarHeight);
      this.removeEventListener('click', this.boundHandleClick);
    }
  }

  if (!customElements.get('cart-bar')) {
    customElements.define('cart-bar', CartBar);
  }
})();
